import React, { useEffect, ReactElement, ReactNode } from "react"
import InputLabel from "@material-ui/core/InputLabel"
import NotchedOutline from "@material-ui/core/OutlinedInput/NotchedOutline"
import { makeStyles, Theme } from "@material-ui/core/styles"

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
    marginTop: "8px",
    marginBottom: theme.spacing(4),
    borderRadius: 10,
  },
  contentWrapper: {
    position: "relative",
  },
  content: {
    padding: theme.spacing(1),
  },
  inputLabel: {
    position: "absolute",
    left: 0,
    top: 0,
    transform: "translate(0, 24px) scale(1)",
  },
  notchedOutline: {
    borderRadius: 10,
    border: `1px solid ${theme.palette.grey[400]}`,
  },
}))

interface Props {
  id: string
  label: string
  children: ReactNode
  className?: string
}

export default function OutlineContainer({
  id,
  label,
  children,
}: Props): ReactElement {
  const [labelWidth, setLabelWidth] = React.useState(0)
  const labelRef = React.useRef(null)
  const classes = useStyles()

  useEffect(() => {
    if (labelRef && labelRef.current && (labelRef.current as any).offsetWidth) {
      setLabelWidth((labelRef.current as any).offsetWidth)
    }
  }, [label])

  return (
    <div className={classes.root}>
      <InputLabel
        ref={labelRef}
        htmlFor={id}
        variant="outlined"
        className={classes.inputLabel}
        shrink
      >
        {label}
      </InputLabel>
      <div className={classes.contentWrapper}>
        <div id={id} className={classes.content}>
          {children}
          <NotchedOutline
            className={classes.notchedOutline}
            notched
            labelWidth={labelWidth}
          />
        </div>
      </div>
    </div>
  )
}
